import { Action } from '@ngrx/store';
import { IToolInfoUpdate } from '@account-users/account/models/IToolInfo';
import {
  IAccountAndUserId,
  IAccountUserLicenseUpdate,
  IAccountUserSectionUpdate,
} from '@account-users/models/IAccountUser';
import { UserLicencePermission } from '@account-users/account/models/LicensePermissionList';
import { IAccountUser } from '@account-users/account/models/IAccountUser';

export enum AccountUserActionTypes {
  LoadAccountUser = '[Account-user] Load Account User',
  LoadAccountUserFailure = '[Account-user] Load Account User Failure',
  LoadAccountUserSuccess = '[Account-user] Load Account User Success',

  LoadAccountUserAfterRoleSuccess = '[Account-user] Load Account User After Role Update Success',
  LoadAccountUserAfterRoleFailure = '[Account-user] Load Account User After Role Update Failure',

  LoadAccountUserPermissions = '[Account-user] Load Account User Permissions',
  LoadAccountUserPermissionsFailure = '[Account-user] Load Account User Permissions Failure',
  LoadAccountUserPermissionsSuccess = '[Account-user] Load Account User Permissions Success',

  LoadAllAccountUserLicenses = '[Account-user] Load All Account User Licenses',
  LoadAllAccountUserLicensesFailure = '[Account-user] Load Account User Licenses Failure',
  LoadAllAccountUserLicensesSuccess = '[Account-user] Load Account User Licenses Success',

  UpdateAccountUserLicensePermissions = '[Account-user] Update Account User Permissions',
  UpdateAccountUserLicensePermissionsSuccess = '[Account-user] Update Account User Permissions Success',
  UpdateAccountUserLicensePermissionFailure = '[Account-user] Update Account User Permissions Failure',

  UpdateAccountUserSectionPermissions = '[Account-user] Update Account User Section Permissions',
  UpdateAccountUserSectionPermissionsSuccess = '[Account-user] Update Account User Section Permissions Success',
  UpdateAccountUserSectionPermissionFailure = '[Account-user] Update Account User Section Permissions Failure',

  UpdateAccountUserRoles = '[Account-user] Update Account User Roles',
  UpdateAccountUserRolesSuccess = '[Account-user] Update Account User Roles Success',
  UpdateAccountUserRolesFailure = '[Account-user] Update Account User Roles Failure',
}

export interface IUpdateLicensePermission {
  userId: string;
  accountId: string;
  toolUpdate: IToolInfoUpdate;
}

export class LoadAccountUser implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUser;
  constructor(public payload: IAccountAndUserId) {}
}

export class LoadAccountUserFailure implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserFailure;
}

export class LoadAccountUserSuccess implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserSuccess;
  constructor(public payload: IAccountUser) {}
}

export class LoadAccountUserPermissions implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserPermissions;
  constructor(public payload: IAccountAndUserId) {}
}

export class LoadAccountUserPermissionsFailure implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserPermissionsFailure;
}

export class LoadAccountUserPermissionsSuccess implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserPermissionsSuccess;
  constructor(public payload: UserLicencePermission[]) {}
}

export class LoadAllAccountUserLicensesAction implements Action {
  readonly type = AccountUserActionTypes.LoadAllAccountUserLicenses;
  constructor(public payload: IAccountAndUserId) {}
}

export class LoadAllAccountUserLicensesActionFailure implements Action {
  readonly type = AccountUserActionTypes.LoadAllAccountUserLicensesFailure;
}

export class LoadAllAccountUserLicensesActionSuccess implements Action {
  readonly type = AccountUserActionTypes.LoadAllAccountUserLicensesSuccess;
  constructor(
    public payload: {
      accountUser;
      userLicenses;
      allLicenses;
      licensePermissions;
      accountLicenses;
      userRoles;
      accountUsers;
      licenseTypes;
    },
  ) {}
}

export class UpdateAccountUserLicensePermissions implements Action {
  readonly type = AccountUserActionTypes.UpdateAccountUserLicensePermissions;
  constructor(public payload: IAccountUserLicenseUpdate) {}
}

export class UpdateAccountUserLicensePermissionsSuccess implements Action {
  readonly type =
    AccountUserActionTypes.UpdateAccountUserLicensePermissionsSuccess;
  constructor(public payload: IAccountAndUserId) {}
}

export class UpdateAccountUserLicensePermissionFailure implements Action {
  readonly type =
    AccountUserActionTypes.UpdateAccountUserLicensePermissionFailure;
}

export class UpdateAccountUserSectionPermissions implements Action {
  readonly type = AccountUserActionTypes.UpdateAccountUserSectionPermissions;
  constructor(public payload: IAccountUserSectionUpdate) {}
}

export class UpdateAccountUserSectionPermissionsSuccess implements Action {
  readonly type =
    AccountUserActionTypes.UpdateAccountUserSectionPermissionsSuccess;
  constructor(public payload: IAccountAndUserId) {}
}

export class UpdateAccountUserSectionPermissionsFailure implements Action {
  readonly type =
    AccountUserActionTypes.UpdateAccountUserSectionPermissionFailure;
}

export class UpdateAccountUserRolesAction implements Action {
  readonly type = AccountUserActionTypes.UpdateAccountUserRoles;
  constructor(
    public payload: {
      role: string;
      userId: string;
      accountId: string;
      toggle: boolean;
    },
  ) {}
}

export class UpdateAccountUserRolesActionSuccess implements Action {
  readonly type = AccountUserActionTypes.UpdateAccountUserRolesSuccess;
  constructor(
    public payload: {
      userId: string;
      accountId: string;
      role: string;
      toggle: boolean;
    },
  ) {}
}

export class UpdateAccountUserRolesActionFailure implements Action {
  readonly type = AccountUserActionTypes.UpdateAccountUserRolesFailure;
}

export class LoadAccountUserAfterRoleSuccess implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserAfterRoleSuccess;
  constructor(
    public payload: {
      user: IAccountUser;
      userLicensePermissions: UserLicencePermission[];
    },
  ) {}
}

export class LoadAccountUserAfterRoleFailure implements Action {
  readonly type = AccountUserActionTypes.LoadAccountUserAfterRoleFailure;
}

export type AccountUserActions =
  | LoadAccountUser
  | LoadAccountUserFailure
  | LoadAccountUserSuccess
  | LoadAccountUserPermissions
  | LoadAccountUserPermissionsFailure
  | LoadAccountUserPermissionsSuccess
  | LoadAllAccountUserLicensesAction
  | LoadAllAccountUserLicensesActionFailure
  | LoadAllAccountUserLicensesActionSuccess
  | UpdateAccountUserLicensePermissions
  | UpdateAccountUserLicensePermissionsSuccess
  | UpdateAccountUserLicensePermissionFailure
  | UpdateAccountUserSectionPermissions
  | UpdateAccountUserSectionPermissionsSuccess
  | UpdateAccountUserSectionPermissionsFailure
  | UpdateAccountUserRolesAction
  | UpdateAccountUserRolesActionSuccess
  | UpdateAccountUserRolesActionFailure
  | LoadAccountUserAfterRoleSuccess
  | LoadAccountUserAfterRoleFailure;
